























import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component
export default class ImplPostOperasiChecklist extends Vue {
  @Prop({ default: () => ({}) }) readonly value!: Record<string, any>;
  @Prop({ default: false }) readonly disabled!: boolean;

  localValue: Record<string, any> = {};

  checkItems = [
    { key: "posisi_sesuai_instruksi", label: "Memposisikan pasien sesuai instruksi medis" },
    { key: "beri_oksigen", label: "Memberikan oksigen" },
    { key: "monitor_vital_sign", label: "Memonitor vital sign" },
    { key: "beri_analgetik", label: "Memberikan analgetik" },
    { key: "dampingi_belum_sadar", label: "Mendampingi selama pasien belum sadar" },
    { key: "pasang_side_rail", label: "Memasang side rail tempat tidur" },
    { key: "antagonis_narkotik", label: "Memberikan antagonis narkotik sesuai SOP" },
    { key: "monitor_kesadaran_reflek_menelan", label: "Memonitor tingkat kesadaran, reflek batuk dan kemampuan menelan" },
    { key: "monitor_recovery_score", label: "Memonitor Aldrete Score / Bromage Score / Stewart Score" }
  ];

  mounted() {
    this.localValue = { ...this.value };
  }

  @Watch("value", { deep: true })
  onValueChange(val) {
    this.localValue = { ...val };
  }

  emitChange() {
    this.$emit("input", { ...this.localValue });
  }
}
